import type { WorkspaceFile, WorkspaceFileUpload } from '../../types/index.js';
import { safeJsonDate, safeJsonDateRequired } from './date.js';

export const normalizeFile = (data: WorkspaceFile<string> | null): WorkspaceFile | null => {
  if (!data) return null;

  return Object.assign(data, {
    createdOn: safeJsonDateRequired(data.createdOn),
    lastDownloadedOn: safeJsonDate(data.lastDownloadedOn),
    lastModifiedOn: safeJsonDateRequired(data.lastModifiedOn),
    publishedOn: safeJsonDate(data.publishedOn),
  });
};

export const normalizeFileUpload = (data: WorkspaceFileUpload<string>): WorkspaceFileUpload => {
  return Object.assign(data, {
    initiatedOn: safeJsonDateRequired(data.initiatedOn),
    lastUpdatedOn: safeJsonDateRequired(data.lastUpdatedOn),
  });
};
